module.exports = __webpack_public_path__ + "img/f50c103.png";